"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _RhumbContext = _interopRequireDefault(require("./internal/RhumbContext"));

var ActionTypes = _interopRequireWildcard(require("./internal/ActionTypes"));

var _Scheduler = require("./internal/Scheduler");

var _performanceNow = _interopRequireDefault(require("./vendor/performanceNow"));

var useNavMarker = function useNavMarker(name) {
  var active = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var context = (0, _react.useContext)(_RhumbContext.default);
  var id = context && context.id;
  var dispatch = context && context.dispatch;
  var enabled = active && typeof context !== 'undefined';
  (0, _react.useEffect)( // eslint-disable-next-line consistent-return
  function () {
    if (enabled) {
      var marker = {
        name: name,
        id: id
      };
      var timestamp = (0, _performanceNow.default)();
      (0, _Scheduler.runWithLowPriority)(function () {
        dispatch({
          type: ActionTypes.MARKER_MOUNTED,
          payload: {
            marker: marker,
            timestamp: timestamp
          }
        });
      }); // eslint-disable-next-line consistent-return

      return function () {
        (0, _Scheduler.runWithLowPriority)(function () {
          dispatch({
            type: ActionTypes.MARKER_UNMOUNTED,
            payload: {
              marker: marker
            }
          });
        });
      };
    }
  }, // dispatch is guaranteed to be static
  [name, id, dispatch, enabled]);
};

var _default = useNavMarker;
exports.default = _default;
module.exports = exports.default;